import React, { useContext, }from 'react';
import { Descriptions, Badge, Typography, } from 'antd';
import { Card } from '../../../UI/Card/Card.component';
import { StationContext } from '../../../../context/station-context';

const { Item } = Descriptions;
const { Paragraph } = Typography;

const labelStyle = {
    fontWeight: 800,
};

const responsiveDescriptionColumns = {
    xxl: 4,
    xl: 2,
    lg: 2,
    md: 1,
    sm: 1,
    xs: 1,
}

export const StationInformationCard = ({...props}) => {

    const [state, ] = useContext(StationContext);
    const station = state.station;

    const { 
        oracleID, 
        contractNumber, 
        city, 
        streetAddress,  
        zip, 
        enableEmailAlerts,
        enablePhoneAlerts,
        comment, 
        email, 
        phone, 
        phoneCarrier,  
        name,
        status,
    } = station;

    const splitAddress = () => {
        let address = [streetAddress, city, station?.state, zip];
        return address.filter(Boolean).join(", ");
    }

    const getStatusBadge = (status) => {
        return <Badge status={status ? 'success' : 'error'} text={status ? 'Active' : 'Inactive'}/>
    }

    const commonDescriptionProps = {
        size: 'small',
        colon: false,
        style: { backgroundColor: 'unset' }, 
        styles: { label: labelStyle }, 
    }

    return(
        <>
            <Card bordered={false} {...props} style={{...props.style, padding: 6}} >
                <Descriptions 
                    {...commonDescriptionProps}
                    column={responsiveDescriptionColumns}
                >
                    <Item label='Station'>{name}</Item>
                    <Item label='Internet Status'>{getStatusBadge(status)}</Item>
                    <Item label='Oracle ID'>{oracleID || 'N/A'}</Item>
                    <Item label='Contract Number'>{contractNumber || 'N/A'}</Item>
                    <Item label='Address'> 
                        { !streetAddress && !city && !streetAddress && !zip ? 'N/A' 
                            : 
                            <>
                                <Paragraph style={{ margin: 0}}>
                                    {splitAddress()}
                                </Paragraph>
                            </>
                        }
                    </Item>
                    <Item label='Email Address'>{email ? email : 'N/A'}</Item>
                    <Item label='Phone Number'>{phone || 'N/A'}</Item>
                    <Item label='Phone Carrier'>{phoneCarrier || 'N/A'}</Item>
                    <Item label='Email Alert Notifications'>{enableEmailAlerts ?  'Enabled' : 'Disabled'}</Item>
                    <Item label='Phone Alert Notifications' span='filled'>{enablePhoneAlerts ?  'Enabled' : 'Disabled'}</Item>
                    <Item label='Comment' span={'filled'}>{(!comment || comment.trim() === "") ? 'N/A' : comment}</Item>
                </Descriptions>
            </Card>
        </>
    );
}